module.exports = "/images/Icon industry-RopesCourse.svg?f3733c07e2855b3b2eea2d257d7d32c2";